import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["statusMsg", "email", "undeliverableAddress"]

  handleFormSuccess (ev) {
    ev.target.reset()
    this.emailTarget.classList.remove("is-invalid")
    this.emailTarget.classList.add("is-valid")
    this.statusMsgTarget.innerText = "Great, you're now subscribed!"
    this.statusMsgTarget.style.color = "#28a745";
  }

  handleFormError(ev) {
    let xmlhttprequest = ev.detail[2]

    this.emailTarget.classList.remove("is-valid")
    this.emailTarget.classList.add("is-invalid")
    this.statusMsgTarget.style.color = "#bc0000"

    switch(xmlhttprequest.status) {
      case 409:
        this.statusMsgTarget.innerText = "You're already subscribed"
        break;
      default:
        this.statusMsgTarget.innerText = "Sorry, we weren't able to register your email. Please check and try again"
    }
  }

  attachAddress () {
    let addressInput = document.querySelector("#ship-address")
    this.undeliverableAddressTarget.value = addressInput.value
  }
}

